/* eslint-disable */

// @ts-nocheck
import React from 'react';

export default function WireframeConsentDesktop() {
    React.useEffect(() => {
        window.C24M = {};
        window.Check24 = {
            getDomain: () => location.host.split('.').reverse().splice(0, 2).reverse().join('.'),

            removeClass: function removeClass(element, className) {
                var ele = document.querySelectorAll(element);

                if (ele) {
                    ele.forEach(function (el) {
                        if (el.classList) {
                            el.classList.remove(className);
                        } else if (Check24.hasClass(el, className)) {
                            var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
                            el.className = el.className.replace(reg, ' ');
                        }
                    });
                }
            },

            show: function (element, mode) {
                if (Array.isArray(element)) {
                    element.forEach(function (elem) {
                        var ele = document.querySelectorAll(elem);
                        ele.forEach(function (el) {
                            if (el) {
                                if (mode) {
                                    if (mode === 'visibility') {
                                        el.style.visibility = 'visible';
                                    } else {
                                        el.style.display = mode;
                                    }
                                } else {
                                    el.style.display = 'block';
                                }
                            }
                        });
                    });
                } else {
                    var ele = document.querySelectorAll(element);
                    ele.forEach(function (el) {
                        if (mode) {
                            if (mode === 'visibility') {
                                el.style.visibility = 'visible';
                            } else {
                                el.style.display = mode;
                            }
                        } else {
                            el.style.display = 'block';
                        }
                    });
                }
            },

            hide: function (element, mode) {
                if (Array.isArray(element)) {
                    element.forEach(function (elem) {
                        var ele = document.querySelectorAll(elem);
                        ele.forEach(function (el) {
                            if (el) {
                                if (mode === 'visibility') {
                                    el.style.visibility = 'hidden';
                                } else {
                                    el.style.display = 'none';
                                }
                            }
                        });
                    });
                } else {
                    var ele = document.querySelectorAll(element);
                    ele.forEach(function (el) {
                        if (el) {
                            if (mode === 'visibility') {
                                el.style.visibility = 'hidden';
                            } else {
                                el.style.display = 'none';
                            }
                        }
                    });
                }
            },

            addClass: function addClass(element, className) {
                var ele = document.querySelectorAll(element);

                if (ele) {
                    ele.forEach(function (el) {
                        if (el.classList) {
                            el.classList.add(className);
                        } else if (!Check24.hasClass(el, className)) {
                            el.className += ' ' + className;
                        }
                    });
                }
            },
        };
        window.Check24.cookieBanner = {
            domain: '.check24.de',
            /* {init: function() {
        // "Legacy case" ("opt-out") for the Spanish products still using the German Wireframe
        // Will be removed once the Spanish products convert to their own Wireframe
        if (document.querySelector(".c24-cookie")) {
            window.Check24.removeClass("body", "c24-cc-visible");
            window.Check24.cookieBanner.initLegacyCookieBanner();
            return;
        }

        var consentWrapper = document.querySelector(".c24-cookie-consent-wrapper");
        if (consentWrapper == null) {
            window.Check24.removeClass("body", "c24-cc-visible");
            return;
        }

        setTimeout (function checkForLayer() {
            if (consentWrapper != null) {
                var layerStyle = window.getComputedStyle(consentWrapper);
                if (consentWrapper.length === 0 || layerStyle.display === "none") {
                    window.Check24.removeClass("body", "c24-cc-visible");
                } else {
                    setTimeout(checkForLayer, 500);
                }
            } else {
                window.Check24.removeClass("body", "c24-cc-visible");
            }
        }, 500);

        // New Cookie Consent Screen case ("opt-in")
        window.Check24.cookieBanner.c24consent.initCookieConsentScreen();
    },
} */ c24consent: {
                refreshLayout: function () {
                    var consentNotice = document.querySelector('.c24-cookie-consent-notice');
                    var consentScreen = document.querySelector('.c24-cookie-consent-screen');
                    window.Check24.show(['.c24-cookie-consent-screen', '.c24-cookie-consent-notice'], 'flex');
                    if (consentNotice.offsetHeight < consentScreen.offsetHeight) {
                        consentNotice.style.height = consentScreen.offsetHeight + 'px';
                        consentScreen.style.height = consentScreen.offsetHeight + 'px';
                    } else {
                        consentScreen.style.height = consentNotice.offsetHeight + 'px';
                        consentNotice.style.height = consentNotice.offsetHeight + 'px';
                    }
                    window.Check24.hide(['.c24-cookie-consent-screen', '.c24-cookie-consent-notice']);
                },
                /* {initCookieConsentScreen: function () {
            var c24consent = window.Check24.cookieBanner.c24consent.getCookieWithName("c24consent");
            if (c24consent && c24consent.indexOf("t") === -1) {
                // If c24consent cookie is set & not marked as temporary => everything is fine => we do not have to show a cookie consent screen
                // Instead, we refresh the lifetime of the existing cookie
                window.Check24.cookieBanner.c24consent.setC24consentCookie(c24consent);
                return;
            }

            // If user had a c24consent cookie that is marked as "temporary", remove that
            // => we need to ask him for his consent.
            if (c24consent && c24consent.indexOf("t") !== -1) {
                window.Check24.cookieBanner.c24consent.unsetCookie("c24consent");
            }

            // Special case: In case the user previously closed the legacy cookie banner (c24cb=1)
            //               and did not opt-out to anything (ch24oo not set or ch24oo === '00000000000'),
            //               we set the c24consent value to "fam" and do not show the Cookie Consent Screen.
            var c24cb = window.Check24.cookieBanner.c24consent.getCookieWithName("c24cb");
            if (c24cb === "1") {
                var ch24oo = window.Check24.cookieBanner.c24consent.getCookieWithName("ch24oo");
                if (ch24oo === null || ch24oo === "00000000000") {
                    window.Check24.cookieBanner.c24consent.setC24consentCookie("fam");
                    return;
                }
            }

            // Show consent screen notice
            window.Check24.cookieBanner.c24consent.showNoticeScreen();
        },
} */ giveConsent: function (consent) {
                    window.Check24.hide(['.c24-cookie-consent-screen', '.c24-cookie-consent-notice']);
                    window.Check24.removeClass('body', 'c24-cc-visible');

                    window.Check24.cookieBanner.c24consent.setC24consentCookie(consent);
                    window.Check24.cookieBanner.c24consent.countCookieConsent(consent);
                    var consentm = window.Check24.cookieBanner.c24consent.marketingConsent;
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'c24consent',
                            c24consent: consent,
                            c24consentm: consent.indexOf('m') !== -1 ? '' : consentm,
                        });
                    }
                    window.dispatchEvent(
                        new CustomEvent('c24consent', {
                            detail: {
                                c24consent: consent,
                                c24consentm: consent.indexOf('m') !== -1 ? '' : consentm,
                            },
                        }),
                    );
                },
                getC24consentCookieDomain: function () {
                    if (window && window.location && window.location.hostname) {
                        return window.location.hostname.split('.').slice(-2).join('.');
                    }
                    return 'check24.de';
                },
                setC24consentCookie: function (value) {
                    var content = 'c24consent=' + value;
                    var domain = 'domain=.' + window.Check24.cookieBanner.c24consent.getC24consentCookieDomain();
                    var sameSite = 'samesite=lax';
                    var path = 'path=/';

                    var d = new Date();
                    if (value === 'f') {
                        d.setTime(d.getTime() + 604800000); /* seven days in milliseconds */
                    } else {
                        d.setTime(d.getTime() + 63072000000); /* two years in milliseconds */
                    }
                    var expires =
                        'expires=' +
                        d.toUTCString(); /* max-age would have been easier here, but does not work in IE < 10 */

                    document.cookie = [content, domain, path, expires, sameSite, 'secure'].join('; ');
                    if (value === 'fam') {
                        document.cookie = [
                            'c24consentm=',
                            domain,
                            path,
                            'expires=Thu, 01 Jan 1970 00:00:00 UTC',
                            sameSite,
                            'secure',
                        ].join('; ');
                    }
                },
                unsetCookie: function (name) {
                    // Similar to `setC24consentCookie`, but uses a negative expiry time => cookie will be removed
                    var content = name + '=';
                    var domain = 'domain=.' + window.Check24.cookieBanner.c24consent.getC24consentCookieDomain();
                    var sameSite = 'samesite=lax';
                    var path = 'path=/';

                    var d = new Date();
                    d.setTime(d.getTime() - 63072000000); /* two years in milliseconds */
                    var expires =
                        'expires=' +
                        d.toUTCString(); /* max-age would have been easier here, but does not work in IE < 10 */

                    document.cookie = [content, domain, path, expires, sameSite, 'secure'].join('; ');
                },
                showConsentScreen: function () {
                    window.Check24.cookieBanner.c24consent.refreshLayout();
                    window.Check24.hide('.c24-cookie-consent-notice', 'visibility');
                    window.Check24.hide('.c24-cookie-consent-notice');
                    window.Check24.show('.c24-cookie-consent-screen', 'visibility');
                    window.Check24.show('.c24-cookie-consent-screen', 'flex');
                    window.Check24.addClass('body', 'c24-cc-visible');
                },
                hideConsentScreen: function () {
                    window.Check24.hide('.c24-cookie-consent-screen', 'visibility');
                    window.Check24.hide('.c24-cookie-consent-screen');
                    window.Check24.removeClass('body', 'c24-cc-visible');
                },
                showNoticeScreen: function () {
                    window.Check24.cookieBanner.c24consent.refreshLayout();
                    window.Check24.hide('.c24-cookie-consent-screen', 'visibility');
                    window.Check24.hide('.c24-cookie-consent-screen');
                    window.Check24.show('.c24-cookie-consent-notice', 'visibility');
                    window.Check24.show('.c24-cookie-consent-notice', 'flex');
                    window.Check24.addClass('body', 'c24-cc-visible');
                },
                getCookieWithName: function (name) {
                    var cookieArr = document.cookie.split(';');

                    for (var i = 0; i < cookieArr.length; i++) {
                        var cookiePair = cookieArr[i].split('=');

                        if (cookiePair[0].trim() === name) {
                            return cookiePair[1];
                        }
                    }

                    return null;
                },
                toggleDescriptionText: function (id, iconId) {
                    var el = document.getElementById(id);
                    if (!el) {
                        return;
                    }

                    if (el.style.display === 'none' || el.style.display === '') {
                        el.style.display = 'block';
                        window.Check24.addClass('#' + iconId, 'c24-cookie-consent-button-more-icon-open');
                        var wrapper = document.querySelector('.c24-cookie-consent-screen-list');
                        wrapper.scrollTo(0, document.getElementById(iconId).offsetTop - wrapper.offsetTop - 15);
                        return;
                    }

                    el.style.display = 'none';
                    window.Check24.removeClass('#' + iconId, 'c24-cookie-consent-button-more-icon-open');
                },
                toggleCheckbox: function (id) {
                    var checkbox = document.getElementById(id);
                    if (!checkbox) {
                        return;
                    }

                    checkbox.checked = !checkbox.checked;

                    if (id === 'check24-cookie-marketing') {
                        for (var i = 1; i <= 5; i++) {
                            var ele = document.getElementById('check24-cookie-marketing-' + i);
                            if (!ele) {
                                return;
                            }
                            if (checkbox.checked) {
                                ele.checked = true;
                            } else {
                                ele.checked = false;
                            }
                        }
                    }
                    if (checkbox.classList && checkbox.classList.contains('c24-cookie-consent-m-toggle')) {
                        var checkedEles = '';
                        for (var i = 1; i <= 5; i++) {
                            var ele = document.getElementById('check24-cookie-marketing-' + i);
                            if (!ele) {
                                return;
                            }
                            if (ele.checked) {
                                checkedEles += i;
                            }
                        }

                        var mCheckbox = document.getElementById('check24-cookie-marketing');
                        if (checkedEles === '12345') {
                            mCheckbox.checked = true;
                        } else {
                            mCheckbox.checked = false;
                        }
                    }
                },
                updateConsentScreen: function () {
                    var c24consent = window.Check24.cookieBanner.c24consent.getCookieWithName('c24consent');
                    var c24consentm = window.Check24.cookieBanner.c24consent.getCookieWithName('c24consentm');

                    if (c24consent) {
                        var analytics = document.getElementById('check24-cookie-analytics');
                        if (analytics) {
                            analytics.checked = c24consent.indexOf('a') !== -1;
                        }
                        var marketing = document.getElementById('check24-cookie-marketing');
                        if (marketing) {
                            if (c24consent.indexOf('m') !== -1) {
                                for (var i = 1; i <= 5; i++) {
                                    var ele = document.getElementById('check24-cookie-marketing-' + i);
                                    ele.checked = true;
                                }
                            } else {
                                if (c24consentm) {
                                    for (var i = 1; i <= 5; i++) {
                                        var ele = document.getElementById('check24-cookie-marketing-' + i);
                                        ele.checked = c24consentm.indexOf(i) !== -1;
                                    }
                                }
                            }
                            marketing.checked = c24consent.indexOf('m') !== -1;
                        }
                    }
                },
                getConfiguredConsent: function () {
                    var result = 'f';

                    var analytics = document.getElementById('check24-cookie-analytics');
                    if (analytics && analytics.checked) {
                        result += 'a';
                    }
                    var marketing = document.getElementById('check24-cookie-marketing');
                    if (
                        marketing &&
                        marketing.checked &&
                        window.Check24.cookieBanner.c24consent.marketingConsent === '12345'
                    ) {
                        result += 'm';
                    }

                    return result;
                },
                marketingConsent: '',
                giveMarketingConsent: function () {
                    var result = '';
                    for (var i = 1; i <= 5; i++) {
                        var ele = document.getElementById('check24-cookie-marketing-' + i);
                        if (ele && ele.checked) {
                            result += i;
                        }
                    }
                    window.Check24.cookieBanner.c24consent.marketingConsent = result;
                    var content = 'c24consentm=' + result;
                    var domain = 'domain=.' + window.Check24.cookieBanner.c24consent.getC24consentCookieDomain();
                    var sameSite = 'samesite=lax';
                    var path = 'path=/';
                    var d = new Date();
                    d.setTime(d.getTime() + 63072000000);
                    var expires = 'expires=' + d.toUTCString();

                    if (result !== '' && result !== '12345') {
                        document.cookie = [content, domain, path, expires, sameSite, 'secure'].join('; ');
                    } else {
                        document.cookie = [
                            'c24consentm=',
                            domain,
                            path,
                            'expires=Thu, 01 Jan 1970 00:00:00 UTC',
                            sameSite,
                            'secure',
                        ].join('; ');
                    }

                    window.Check24.cookieBanner.c24consent.giveConsent(
                        window.Check24.cookieBanner.c24consent.getConfiguredConsent(),
                    );
                },
                countCookieConsent: function (value) {
                    var request = new XMLHttpRequest();

                    if (!request) {
                        return;
                    }

                    request.open(
                        'GET',
                        'https://www.' +
                            window.Check24.getDomain() +
                            '/ajax/misc/count-cookie-consent/?c24consent=' +
                            value,
                    );
                    request.send();
                },
            },
            /* {initLegacyCookieBanner: function () {
        var button = document.querySelector(".c24-cookie-button");
        window.Check24.cookieBanner.domain = "." + window.Check24.getDomain();
        window.Check24.removeClass(".c24-cookie", "c24-cookie-hide");
        if (window.Check24.cookieBanner.getCookie() != 1 && button) {
            window.Check24.cookieBanner.showBanner(button);
        }
    },
} */ getCookie: function () {
                var value = '; ' + document.cookie;
                var parts = value.split('; ' + 'c24cb' + '=');
                if (parts.length == 2) {
                    return parts.pop().split(';').shift();
                } else {
                    return '';
                }
            },
            setCookie: function () {
                var date = new Date();
                date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
                document.cookie =
                    'c24cb=1; expires=' +
                    date.toGMTString() +
                    '; path=/; domain=' +
                    window.Check24.cookieBanner.domain +
                    '; SameSite=lax; secure';
            },
            /* {showBanner: function(button) {
        window.Check24.addClass(".c24-cookie", "c24-cookie-animate");
        button.addEventListener("click", function() {
            window.Check24.cookieBanner.setCookie();
            window.Check24.cookieBanner.hideBanner();
        });
    },
} */ /* {hideBanner: function() {
        window.Check24.removeClass(".c24-cookie", "c24-cookie-animate");
    }
} */
        };
    }, []);

    const inlineHandler0 = () => {
        window.Check24.cookieBanner.c24consent.giveConsent('f');
    };

    const inlineHandler1 = () => {
        window.Check24.cookieBanner.c24consent.showConsentScreen();
    };

    const inlineHandler2 = () => {
        window.Check24.cookieBanner.c24consent.giveConsent('fam');
    };

    const inlineHandler3 = () => {
        window.Check24.cookieBanner.c24consent.showNoticeScreen();
    };

    const inlineHandler4 = () => {
        event.stopPropagation();
        window.event.cancelBubble = true;
    };

    const inlineHandler5 = () => {
        window.Check24.cookieBanner.c24consent.toggleDescriptionText(
            'c24-cookie-functional-text',
            'c24-cookie-consent-functional-more-icon',
        );
    };

    const inlineHandler6 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-analytics');
    };

    const inlineHandler7 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-analytics');
    };

    const inlineHandler8 = () => {
        window.Check24.cookieBanner.c24consent.toggleDescriptionText(
            'c24-cookie-analytics-text',
            'c24-cookie-consent-analytics-more-icon',
        );
    };

    const inlineHandler9 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing');
    };

    const inlineHandler10 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing');
    };

    const inlineHandler11 = () => {
        window.Check24.cookieBanner.c24consent.toggleDescriptionText(
            'c24-cookie-marketing-text',
            'c24-cookie-consent-marketing-more-icon',
        );
    };

    const inlineHandler12 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing-1');
    };

    const inlineHandler13 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing-1');
    };

    const inlineHandler14 = () => {
        window.Check24.cookieBanner.c24consent.toggleDescriptionText(
            'c24-cookie-marketing-1-text',
            'c24-cookie-consent-marketing-1-more-icon',
        );
    };

    const inlineHandler15 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing-2');
    };

    const inlineHandler16 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing-2');
    };

    const inlineHandler17 = () => {
        window.Check24.cookieBanner.c24consent.toggleDescriptionText(
            'c24-cookie-marketing-2-text',
            'c24-cookie-consent-marketing-2-more-icon',
        );
    };

    const inlineHandler18 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing-3');
    };

    const inlineHandler19 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing-3');
    };

    const inlineHandler20 = () => {
        window.Check24.cookieBanner.c24consent.toggleDescriptionText(
            'c24-cookie-marketing-3-text',
            'c24-cookie-consent-marketing-3-more-icon',
        );
    };

    const inlineHandler21 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing-4');
    };

    const inlineHandler22 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing-4');
    };

    const inlineHandler23 = () => {
        window.Check24.cookieBanner.c24consent.toggleDescriptionText(
            'c24-cookie-marketing-4-text',
            'c24-cookie-consent-marketing-4-more-icon',
        );
    };

    const inlineHandler24 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing-5');
    };

    const inlineHandler25 = () => {
        window.Check24.cookieBanner.c24consent.toggleCheckbox('check24-cookie-marketing-5');
    };

    const inlineHandler26 = () => {
        window.Check24.cookieBanner.c24consent.toggleDescriptionText(
            'c24-cookie-marketing-5-text',
            'c24-cookie-consent-marketing-5-more-icon',
        );
    };

    const inlineHandler27 = () => {
        window.Check24.cookieBanner.c24consent.giveMarketingConsent();
    };

    const inlineHandler28 = () => {
        window.Check24.cookieBanner.c24consent.giveConsent('fam');
    };

    return (
        <>
            <style
                jsx
                global
            >{`
                .c24-blocking-layer,
                .c24-strict-blocking-layer {
                    display: none;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    z-index: 20000;
                    width: 100%;
                    min-height: 100%;
                    cursor: pointer;
                }

                .c24-strict-blocking-layer {
                    cursor: inherit;
                    position: fixed;
                }

                .c24-logo,
                .c24-cc-logo,
                .c24-footer-logo {
                    background-image: url('data:image/svg+xml;base64,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');
                    background-repeat: no-repeat;
                }

                input.c24-button,
                button.c24-button,
                a.c24-button,
                a.c24-cookie-button,
                .c24-cookie-consent-button {
                    text-decoration: none !important;
                    font-size: 13px;
                    padding: 5px;
                    font-family: Arial, Helvetica, sans-serif;
                    cursor: pointer;
                    font-weight: bold;
                    border: 0 !important;
                    display: inline-block;
                    background: #0563c1;
                    background: -webkit-gradient(
                        linear,
                        left top,
                        left bottom,
                        color-stop(0%, rgba(5, 99, 193, 1)),
                        color-stop(100%, rgba(5, 99, 193, 1)),
                        color-stop(100%, rgba(5, 99, 193, 1))
                    ); /* Chrome,Safari4+ */
                    text-align: center;
                    vertical-align: middle;
                    color: #fff;
                    -webkit-border-radius: 3px;
                    -moz-border-radius: 3px;
                    border-radius: 3px;
                }

                input.c24-button:hover,
                button.c24-button:hover,
                button.c24-button-xl:hover,
                button.c24-button-xxl:hover,
                input.c24-button-xl:hover,
                input.c24-button-xxl:hover,
                input.c24-button-xxxl:hover,
                input.c24-button-s:hover,
                a.c24-button:hover,
                a.c24-button-xl:hover,
                a.c24-button-xxl:hover,
                a.c24-button-s:hover,
                a.c24-button-xxxl:hover,
                span.c24-button-xxxl:hover,
                input.c24-button:active,
                button.c24-button:active,
                button.c24-button-xl:active,
                button.c24-button-xxl:active,
                input.c24-button-xl:active,
                input.c24-button-xxl:active,
                input.c24-button-xxxl:active,
                input.c24-button-s:active,
                a.c24-button:active,
                a.c24-button-xl:active,
                a.c24-button-xxl:active,
                a.c24-button-s:active,
                a.c24-button-xxxl:active,
                span.c24-button-xxxl:active,
                a.c24-cookie-button:hover,
                .c24-cookie-consent-button:not(.c24-cookie-consent-button-secondary):hover {
                    background: #064e9c;
                    color: #ffffff;
                    background: -webkit-gradient(
                        linear,
                        left top,
                        left bottom,
                        color-stop(0%, rgba(6, 78, 156, 1)),
                        color-stop(100%, rgba(6, 78, 156, 1)),
                        color-stop(100%, rgba(6, 78, 156, 1))
                    ); /* Chrome,Safari4+ */
                }

                .c24-cookie-consent-notice *,
                .c24-cookie-consent-screen * {
                    -webkit-text-size-adjust: none !important;
                }

                .c24-cookie-consent-wrapper .c24-cc-logo {
                    margin: 0;
                    width: 130px;
                    height: 34px;
                    float: left;
                }

                .c24-cookie-consent-wrapper {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    -webkit-box-pack: center;
                    -ms-flex-pack: center;
                    justify-content: center;
                    -webkit-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    position: fixed;
                    z-index: 20001;
                    visibility: hidden;
                }

                .c24-cookie-consent-notice:before,
                .c24-cookie-consent-screen:before {
                    background-image: url('data:image/svg+xml;base64,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');
                    background-size: 100%;
                    background-repeat: no-repeat;
                    width: 96px;
                    height: 97px;
                    position: absolute;
                    top: -73px;
                    left: 227px;
                    content: ' ';
                }

                .c24-cookie-consent-notice,
                .c24-cookie-consent-screen {
                    background: rgba(4, 20, 60, 0.8);
                    border-radius: 5px;
                    padding: 30px 35px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    color: #ffffff;
                    width: 530px;
                    min-width: 530px;
                    max-width: 530px;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-flow: column;
                    flex-flow: column;
                    visibility: hidden;
                    z-index: 20001;
                    position: relative;
                }

                .c24-cookie-consent-wrapper .c24-cookie-consent-notice-title,
                .c24-cookie-consent-wrapper .c24-cookie-consent-screen-title {
                    margin-top: 0;
                    margin-bottom: 10px;
                    font-weight: 700;
                    font-size: 20px;
                    line-height: 24px;
                }

                .c24-cookie-consent-notice-cnt,
                .c24-cookie-consent-screen-cnt {
                    -ms-flex-negative: 0;
                    flex-shrink: 0;
                    -webkit-box-flex: 1;
                    -ms-flex-positive: 1;
                    flex-grow: 1;
                }

                .c24-cookie-consent-notice-cnt div,
                .c24-cookie-consent-screen-cnt div {
                    font-size: 16px;
                    line-height: 24px;
                }

                .c24-cookie-consent-notice a {
                    color: #ffffff;
                    text-decoration: underline;
                }

                .c24-cookie-consent-notice-text {
                    margin-bottom: 30px;
                    -ms-flex-negative: 0;
                    flex-shrink: 0;
                    -webkit-flex-shrink: 0;
                    -webkit-box-flex: 1;
                    -ms-flex-positive: 1;
                    flex-grow: 1;
                    -webkit-flex-grow: 1;
                }

                .c24-cookie-consent-wrapper .c24-cookie-consent-imprint,
                .c24-cookie-consent-wrapper .c24-cookie-consent-backlink,
                .c24-cookie-consent-wrapper .c24-cookie-consent-functional {
                    color: #ffffff;
                    text-decoration: underline;
                    float: right;
                    font-size: 16px;
                    line-height: 30px;
                }

                .c24-cookie-consent-wrapper .c24-cookie-consent-imprint {
                    line-height: 22px;
                }

                .c24-cookie-consent-wrapper .c24-cookie-consent-functional,
                .c24-cookie-consent-wrapper .c24-cookie-consent-backlink {
                    line-height: 16px;
                }

                .c24-cookie-consent-notice-buttons,
                .c24-cookie-consent-screen-buttons {
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    -ms-flex-negative: 0;
                    flex-shrink: 0;
                    -webkit-flex-shrink: 0;
                }

                .c24-cookie-consent-notice-buttons {
                    margin-bottom: 15px;
                }

                .c24-cookie-consent-screen-buttons {
                    margin-top: auto;
                    padding-top: 25px;
                }

                .c24-cookie-consent-button {
                    text-decoration: none;
                    font-size: 18px;
                    color: #ffffff;
                    padding: 12px 0;
                    float: right;
                    width: 222px;
                    font-weight: normal;
                }

                .c24-cookie-consent-button-secondary {
                    float: left;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    background: transparent;
                    border: 1px solid #dcdcdc !important;
                    padding: 11px 0;
                }

                .c24-cookie-consent-screen-list {
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    max-height: 166px;
                    overflow-y: scroll;
                    border-top: 1px solid #ffffff;
                    border-bottom: 1px solid #ffffff;
                }

                .c24-cookie-consent-screen-list-entry {
                    padding: 15px 15px 15px 0;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    border-top: 1px solid #ffffff;
                }

                .c24-cookie-consent-screen-list-entry-header {
                    cursor: pointer;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                }

                .c24-cookie-consent-screen-list-entry:first-child {
                    border-top: none;
                }

                .c24-cookie-consent-screen-list-entry-header > div:nth-child(1) {
                    padding-right: 10px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                }

                .c24-cookie-consent-screen-list-entry-header > div:nth-child(2) {
                    padding-right: 10px;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    -webkit-box-flex: 1;
                    -ms-flex-positive: 1;
                    flex-grow: 1;
                    font-size: 16px;
                    line-height: 18px;
                    font-weight: 700;
                    cursor: pointer;
                }

                .c24-cookie-consent-screen-list-entry-header > div:nth-child(3) {
                    color: #333333;
                    width: 50px;
                }

                .c24-cookie-consent-screen-list-entry-header input[type='checkbox'] {
                    display: none;
                }

                .c24-cookie-consent-screen-list-entry-header div:first-child span:before {
                    content: '';
                    display: inline-block;
                    width: 18px;
                    height: 18px;
                    background: #ffffff;
                    border: 1px solid #999999;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    border-radius: 5px;
                }

                .c24-cookie-consent-screen-list-entry-header input[type='checkbox']:checked + span:before {
                    background: #ffffff url('https://www.check24.de/assets/images/web/svg/haken-darkblue.svg') no-repeat
                        center;
                    background-size: contain;
                    border: 1px solid #999999;
                    width: 18px;
                    height: 18px;
                }

                .c24-cookie-consent-screen-list-entry-header input[type='checkbox'][disabled]:checked + span:before {
                    background-color: #b4b4b4;
                    border: 1px solid #999999;
                }

                .c24-cookie-consent-button-more-icon {
                    display: block;
                    width: 14px;
                    height: 24px;
                    float: right;
                }

                .c24-cookie-consent-button-more-icon-open {
                    -webkit-transform: rotate(180deg);
                    -ms-transform: rotate(180deg);
                    transform: rotate(180deg);
                }

                .c24-cookie-consent-screen-list-entry-content {
                    display: none;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    line-height: 18px;
                    padding-top: 10px;
                }

                .c24-cookie-consent-buttonlink {
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    background: transparent !important;
                    -webkit-box-shadow: none;
                    box-shadow: none;
                    float: left;
                    padding: 11px 0;
                    border: 1px solid #dcdcdc !important;
                }

                .c24-cookie-consent-wrapper ::-webkit-scrollbar {
                    width: 5px;
                    padding-left: 15px;
                }

                .c24-cookie-consent-wrapper ::-webkit-scrollbar-thumb {
                    background: #b4b4b4;
                }

                body.c24-cc-visible {
                    width: 100%;
                    position: fixed;
                    overflow-y: scroll;
                }

                .c24-cc-visible .c24-cookie-consent-wrapper {
                    visibility: visible;
                }

                .c24-cc-visible .c24-strict-blocking-layer {
                    display: block;
                }

                .c24-cc-visible .c24-cookie-consent-notice {
                    visibility: visible;
                }

                .c24-cc-visible .c24-cookie-consent-screen {
                    display: none;
                }

                .c24-cookie-consent-screen-list-m {
                    padding-left: 15px;
                }

                .c24-cookie-consent-screen-list-m-title {
                    font-weight: bold;
                    margin: 17px 0 15px;
                }

                .c24-cookie-consent-screen-list-m-entry {
                    margin-bottom: 15px;
                }

                .c24-cookie-consent-screen-list-m-entry
                    .c24-cookie-consent-screen-list-entry-header
                    > div:nth-child(2) {
                    line-height: 24px;
                    margin-top: -2px;
                }

                .c24-cookie-consent-screen-list-m-entry .c24-cookie-consent-button-more-icon {
                    margin-top: -2px;
                }

                .c24-cookie-consent-screen-list-m-entry .c24-cookie-consent-screen-list-entry-content {
                    padding-left: 29px;
                }

                a.c24-cookie-consent-cookielink,
                a.c24-cookie-consent-cookielink:hover {
                    color: #fff;
                    text-decoration: underline;
                }

                @media print {
                    .c24-cookie-consent-wrapper {
                        display: none;
                    }
                }

                .consent-inline-style-0 {
                    margin-bottom: 20px !important;
                }

                .consent-inline-style-1 {
                    margin-bottom: 20px !important;
                }

                .consent-inline-style-2 {
                    margin-bottom: 20px !important;
                }

                .consent-inline-style-3 {
                    cursor: initial !important;
                }

                .consent-inline-style-4 {
                    cursor: initial !important;
                }

                .c24-cookie-consent-functional {
                    cursor: pointer;
                }
                .c24-cookie-consent-backlink {
                    cursor: pointer;
                }
            `}</style>
            <div
                className={`c24-cookie-consent-wrapper`}
                data-nosnippet
            >
                <div
                    className={`c24-cookie-consent-notice`}
                    data-nosnippet="true"
                >
                    <div className={`c24-cookie-consent-notice-cnt clearfix consent-inline-style-0`}>
                        <div className={`c24-cc-logo`}></div>
                        <span
                            className={`c24-cookie-consent-functional`}
                            role="button"
                            onClick={inlineHandler0}
                        >
                            Nur notwendige Cookies
                        </span>
                    </div>
                    <div className={`c24-cookie-consent-notice-cnt`}>
                        <div className={`c24-cookie-consent-notice-text`}>
                            <div className={`c24-cookie-consent-notice-title`}>Unvergleichlich lecker</div>
                            <div>
                                Mit dem Klick auf &bdquo;Geht klar&rdquo; erm&ouml;glichen Sie uns Ihnen &uuml;ber
                                Cookies ein verbessertes Nutzungserlebnis zu servieren und dieses kontinuierlich zu
                                verbessern. Damit k&ouml;nnen wir Ihnen personalisierte Empfehlungen auch auf
                                Drittseiten ausspielen. &Uuml;ber &bdquo;Anpassen&rdquo; k&ouml;nnen Sie Ihre
                                pers&ouml;nlichen Pr&auml;ferenzen festlegen. Dies ist auch nachtr&auml;glich jederzeit
                                m&ouml;glich. Mit dem Klick auf &bdquo;Nur notwendige Cookies&rdquo; werden lediglich
                                technisch notwendige Cookies gespeichert.
                            </div>
                        </div>
                    </div>
                    <div className={`c24-cookie-consent-notice-buttons clearfix`}>
                        <span
                            className={`c24-cookie-consent-button c24-cookie-consent-button-secondary`}
                            role="button"
                            onClick={inlineHandler1}
                        >
                            Anpassen
                        </span>
                        <span
                            className={`c24-cookie-consent-button`}
                            role="button"
                            onClick={inlineHandler2}
                        >
                            Geht klar
                        </span>
                    </div>
                    <a
                        className={`c24-cookie-consent-imprint margin-bottom-8`}
                        href={`https://www.check24.de/unternehmen/impressum/#cookies`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Datenschutzerkl&auml;rung
                    </a>
                    <a
                        className={`c24-cookie-consent-imprint margin-bottom-8`}
                        href={`https://www.check24.de/unternehmen/impressum/`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Impressum
                    </a>
                </div>
                <div className={`c24-cookie-consent-screen`}>
                    <div className={`c24-cookie-consent-screen-cnt clearfix consent-inline-style-1`}>
                        <div className={`c24-cc-logo`}></div>
                        <span
                            className={`c24-cookie-consent-backlink`}
                            role="button"
                            onClick={inlineHandler3}
                        >
                            &laquo; zur&uuml;ck
                        </span>
                    </div>
                    <div
                        className={`c24-cookie-consent-screen-cnt`}
                        onClick={inlineHandler4}
                    >
                        <div className={`c24-cookie-consent-screen-header`}>
                            <div>
                                <div className={`c24-cookie-consent-screen-title`}>
                                    Ihre Cookie-Pr&auml;ferenzen verwalten
                                </div>
                                <div className={`consent-inline-style-2`}>
                                    W&auml;hlen Sie, welche Cookies Sie auf check24.de akzeptieren.
                                    <br />
                                    Die Cookierichtlinie finden Sie{' '}
                                    <a
                                        className={`c24-cookie-consent-cookielink`}
                                        href={`https://www.check24.de/unternehmen/cookiehinweis/`}
                                        target="_blank"
                                    >
                                        hier.
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className={`c24-cookie-consent-screen-list`}>
                            <div className={`c24-cookie-consent-screen-list-entry`}>
                                <div className={`c24-cookie-consent-screen-list-entry-header`}>
                                    <div className={`consent-inline-style-3`}>
                                        <input
                                            id="check24-cookie-functional"
                                            type="checkbox"
                                            checked={true}
                                            disabled={true}
                                        />
                                        <span></span>
                                    </div>
                                    <div className={`consent-inline-style-4`}>Notwendig</div>
                                    <div onClick={inlineHandler5}>
                                        <span
                                            className={`c24-cookie-consent-button-more-icon`}
                                            id="c24-cookie-consent-functional-more-icon"
                                        >
                                            <svg
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 189.5 100"
                                                xmlSpace="preserve"
                                            >
                                                <polygon
                                                    fill="#b4b4b4"
                                                    points="0,0 189.5,0 89.5,100"
                                                ></polygon>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                                <div
                                    className={`c24-cookie-consent-screen-list-entry-content`}
                                    id="c24-cookie-functional-text"
                                >
                                    Diese Cookies und andere Informationen sind f&uuml;r die Funktion unserer Services
                                    unbedingt erforderlich. Sie garantieren, dass unser Service sicher und so wie von
                                    Ihnen gew&uuml;nscht funktioniert. Daher kann man sie nicht deaktivieren.
                                    <br />
                                    <br />
                                    <a
                                        className={`c24-cookie-consent-cookielink`}
                                        href={`https://www.check24.de/unternehmen/cookiehinweis/`}
                                        target="_blank"
                                    >
                                        Zur Cookierichtlinie
                                    </a>
                                </div>
                            </div>
                            <div className={`c24-cookie-consent-screen-list-entry`}>
                                <div className={`c24-cookie-consent-screen-list-entry-header`}>
                                    <div onClick={inlineHandler6}>
                                        <input
                                            id="check24-cookie-analytics"
                                            type="checkbox"
                                        />
                                        <span></span>
                                    </div>
                                    <div onClick={inlineHandler7}>Analytisch</div>
                                    <div onClick={inlineHandler8}>
                                        <span
                                            className={`c24-cookie-consent-button-more-icon`}
                                            id="c24-cookie-consent-analytics-more-icon"
                                        >
                                            <svg
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 189.5 100"
                                                xmlSpace="preserve"
                                            >
                                                <polygon
                                                    fill="#b4b4b4"
                                                    points="0,0 189.5,0 89.5,100"
                                                ></polygon>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                                <div
                                    className={`c24-cookie-consent-screen-list-entry-content`}
                                    id="c24-cookie-analytics-text"
                                >
                                    Wir m&ouml;chten f&uuml;r Sie unseren Service so gut wie m&ouml;glich machen. Daher
                                    verbessern wir unsere Services und Ihr Nutzungserlebnis stetig. Um dies zu tun,
                                    m&ouml;chten wir die Nutzung des Services analysieren und in statistischer Form
                                    auswerten.
                                    <br />
                                    <br />
                                    <a
                                        className={`c24-cookie-consent-cookielink`}
                                        href={`https://www.check24.de/unternehmen/cookiehinweis/`}
                                        target="_blank"
                                    >
                                        Zur Cookierichtlinie
                                    </a>
                                </div>
                            </div>
                            <div className={`c24-cookie-consent-screen-list-entry`}>
                                <div className={`c24-cookie-consent-screen-list-entry-header`}>
                                    <div onClick={inlineHandler9}>
                                        <input
                                            id="check24-cookie-marketing"
                                            type="checkbox"
                                        />
                                        <span></span>
                                    </div>
                                    <div onClick={inlineHandler10}>Marketing</div>
                                    <div onClick={inlineHandler11}>
                                        <span
                                            className={`c24-cookie-consent-button-more-icon`}
                                            id="c24-cookie-consent-marketing-more-icon"
                                        >
                                            <svg
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                x="0px"
                                                y="0px"
                                                viewBox="0 0 189.5 100"
                                                xmlSpace="preserve"
                                            >
                                                <polygon
                                                    fill="#b4b4b4"
                                                    points="0,0 189.5,0 89.5,100"
                                                ></polygon>
                                            </svg>
                                        </span>
                                    </div>
                                </div>
                                <div
                                    className={`c24-cookie-consent-screen-list-entry-content`}
                                    id="c24-cookie-marketing-text"
                                >
                                    Um Ihnen unser Angebot kostenfrei anbieten zu k&ouml;nnen, finanzieren wir uns u.a.
                                    durch Werbeeinblendungen und richten werbliche und nicht-werbliche Inhalte auf Ihre
                                    Interessen aus. Daf&uuml;r arbeiten wir mit ausgew&auml;hlten Partnern zusammen.
                                    Ihre Einstellungen k&ouml;nnen Sie jederzeit mit Klick auf Datenschutz im unteren
                                    Bereich unserer Webseite anpassen. Ausf&uuml;hrlichere Informationen zu den
                                    folgenden ausgef&uuml;hrten Verarbeitungszwecken finden Sie ebenfalls in unserer
                                    Datenschutzerkl&auml;rung.
                                    <div className={`c24-cookie-consent-screen-list-m-title`}>
                                        Wir ben&ouml;tigen Ihre Zustimmung f&uuml;r die folgenden Verarbeitungszwecke:
                                    </div>
                                    <div className={`c24-cookie-consent-screen-list-m clearfix`}>
                                        <div className={`c24-cookie-consent-screen-list-m-entry clearfix`}>
                                            <div className={`c24-cookie-consent-screen-list-entry-header`}>
                                                <div onClick={inlineHandler12}>
                                                    <input
                                                        className={`c24-cookie-consent-m-toggle`}
                                                        id="check24-cookie-marketing-1"
                                                        type="checkbox"
                                                    />
                                                    <span></span>
                                                </div>
                                                <div onClick={inlineHandler13}>
                                                    Informationen auf einem Ger&auml;t speichern und/oder abrufen
                                                </div>
                                                <div onClick={inlineHandler14}>
                                                    <span
                                                        className={`c24-cookie-consent-button-more-icon`}
                                                        id="c24-cookie-consent-marketing-1-more-icon"
                                                    >
                                                        <svg
                                                            version="1.1"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            x="0px"
                                                            y="0px"
                                                            viewBox="0 0 189.5 100"
                                                            xmlSpace="preserve"
                                                        >
                                                            <polygon
                                                                fill="#b4b4b4"
                                                                points="0,0 189.5,0 89.5,100"
                                                            ></polygon>
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className={`c24-cookie-consent-screen-list-entry-content`}
                                                id="c24-cookie-marketing-1-text"
                                            >
                                                F&uuml;r die Ihnen angezeigten Verarbeitungszwecke k&ouml;nnen Cookies,
                                                Ger&auml;te-Kennungen oder andere Informationen auf Ihrem Ger&auml;t
                                                gespeichert oder abgerufen werden.
                                            </div>
                                        </div>
                                        <div className={`c24-cookie-consent-screen-list-m-entry clearfix`}>
                                            <div className={`c24-cookie-consent-screen-list-entry-header`}>
                                                <div onClick={inlineHandler15}>
                                                    <input
                                                        className={`c24-cookie-consent-m-toggle`}
                                                        id="check24-cookie-marketing-2"
                                                        type="checkbox"
                                                    />
                                                    <span></span>
                                                </div>
                                                <div onClick={inlineHandler16}>Auswahl einfacher Anzeigen</div>
                                                <div onClick={inlineHandler17}>
                                                    <span
                                                        className={`c24-cookie-consent-button-more-icon`}
                                                        id="c24-cookie-consent-marketing-2-more-icon"
                                                    >
                                                        <svg
                                                            version="1.1"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            x="0px"
                                                            y="0px"
                                                            viewBox="0 0 189.5 100"
                                                            xmlSpace="preserve"
                                                        >
                                                            <polygon
                                                                fill="#b4b4b4"
                                                                points="0,0 189.5,0 89.5,100"
                                                            ></polygon>
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className={`c24-cookie-consent-screen-list-entry-content`}
                                                id="c24-cookie-marketing-2-text"
                                            >
                                                Anzeigen k&ouml;nnen Ihnen basierend auf den Inhalten, die Sie ansehen,
                                                der Anwendung, die Sie verwenden oder Ihrem ungef&auml;hren Standort
                                                oder Ihrem Ger&auml;tetyp eingeblendet werden.
                                            </div>
                                        </div>
                                        <div className={`c24-cookie-consent-screen-list-m-entry clearfix`}>
                                            <div className={`c24-cookie-consent-screen-list-entry-header`}>
                                                <div onClick={inlineHandler18}>
                                                    <input
                                                        className={`c24-cookie-consent-m-toggle`}
                                                        id="check24-cookie-marketing-3"
                                                        type="checkbox"
                                                    />
                                                    <span></span>
                                                </div>
                                                <div onClick={inlineHandler19}>
                                                    Ein personalisiertes Anzeigen-Profil erstellen
                                                </div>
                                                <div onClick={inlineHandler20}>
                                                    <span
                                                        className={`c24-cookie-consent-button-more-icon`}
                                                        id="c24-cookie-consent-marketing-3-more-icon"
                                                    >
                                                        <svg
                                                            version="1.1"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            x="0px"
                                                            y="0px"
                                                            viewBox="0 0 189.5 100"
                                                            xmlSpace="preserve"
                                                        >
                                                            <polygon
                                                                fill="#b4b4b4"
                                                                points="0,0 189.5,0 89.5,100"
                                                            ></polygon>
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className={`c24-cookie-consent-screen-list-entry-content`}
                                                id="c24-cookie-marketing-3-text"
                                            >
                                                &Uuml;ber Sie und Ihre Interessen kann ein Profil erstellt werden, um
                                                Ihnen f&uuml;r Sie relevante personalisierte Anzeigen einzublenden.
                                            </div>
                                        </div>
                                        <div className={`c24-cookie-consent-screen-list-m-entry clearfix`}>
                                            <div className={`c24-cookie-consent-screen-list-entry-header`}>
                                                <div onClick={inlineHandler21}>
                                                    <input
                                                        className={`c24-cookie-consent-m-toggle`}
                                                        id="check24-cookie-marketing-4"
                                                        type="checkbox"
                                                    />
                                                    <span></span>
                                                </div>
                                                <div onClick={inlineHandler22}>
                                                    Personalisierte Anzeigen ausw&auml;hlen
                                                </div>
                                                <div onClick={inlineHandler23}>
                                                    <span
                                                        className={`c24-cookie-consent-button-more-icon`}
                                                        id="c24-cookie-consent-marketing-4-more-icon"
                                                    >
                                                        <svg
                                                            version="1.1"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            x="0px"
                                                            y="0px"
                                                            viewBox="0 0 189.5 100"
                                                            xmlSpace="preserve"
                                                        >
                                                            <polygon
                                                                fill="#b4b4b4"
                                                                points="0,0 189.5,0 89.5,100"
                                                            ></polygon>
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className={`c24-cookie-consent-screen-list-entry-content`}
                                                id="c24-cookie-marketing-4-text"
                                            >
                                                Personalisierte Anzeigen k&ouml;nnen Ihnen basierend auf einem &uuml;ber
                                                Sie erstellten Profil eingeblendet werden.
                                            </div>
                                        </div>
                                        <div className={`c24-cookie-consent-screen-list-m-entry clearfix`}>
                                            <div className={`c24-cookie-consent-screen-list-entry-header`}>
                                                <div onClick={inlineHandler24}>
                                                    <input
                                                        className={`c24-cookie-consent-m-toggle`}
                                                        id="check24-cookie-marketing-5"
                                                        type="checkbox"
                                                    />
                                                    <span></span>
                                                </div>
                                                <div onClick={inlineHandler25}>
                                                    Ein personalisiertes Inhalts-Profil erstellen
                                                </div>
                                                <div onClick={inlineHandler26}>
                                                    <span
                                                        className={`c24-cookie-consent-button-more-icon`}
                                                        id="c24-cookie-consent-marketing-5-more-icon"
                                                    >
                                                        <svg
                                                            version="1.1"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            x="0px"
                                                            y="0px"
                                                            viewBox="0 0 189.5 100"
                                                            xmlSpace="preserve"
                                                        >
                                                            <polygon
                                                                fill="#b4b4b4"
                                                                points="0,0 189.5,0 89.5,100"
                                                            ></polygon>
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                            <div
                                                className={`c24-cookie-consent-screen-list-entry-content`}
                                                id="c24-cookie-marketing-5-text"
                                            >
                                                &Uuml;ber Sie und Ihre Interessen kann ein Profil erstellt werden, um
                                                Ihnen f&uuml;r Sie relevante personalisierte Inhalte anzuzeigen.
                                            </div>
                                        </div>
                                    </div>
                                    <a
                                        className={`c24-cookie-consent-cookielink`}
                                        href={`https://www.check24.de/unternehmen/cookiehinweis/`}
                                        target="_blank"
                                    >
                                        Zur Cookierichtlinie
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`c24-cookie-consent-screen-buttons clearfix`}>
                        <span
                            className={`c24-cookie-consent-button c24-cookie-consent-buttonlink`}
                            role="button"
                            onClick={inlineHandler27}
                        >
                            Auswahl speichern
                        </span>
                        <span
                            className={`c24-cookie-consent-button`}
                            role="button"
                            onClick={inlineHandler28}
                        >
                            Alle akzeptieren
                        </span>
                    </div>
                </div>
                <div className={`c24-strict-blocking-layer`}></div>
            </div>
        </>
    );
}
